module.exports = __webpack_public_path__ + "img/95.7c906081.jpg";